import { apiPost } from '../api/client'
import type { SoftseeDoor } from '../api/devices'

/** Maparea formularelor CI3 (installKit / updateKit / uninstall) pe POST-ul v4. */

export function fieldsOf(form: HTMLFormElement): Record<string, string> {
  const out: Record<string, string> = {}
  const data = new FormData(form)
  data.forEach((value, key) => {
    if (typeof value === 'string') out[key] = value
  })
  return out
}

export function kitPostTarget(
  form: HTMLFormElement,
  deviceId: number,
  door: SoftseeDoor,
): { path: string; success: string } | null {
  const action = form.getAttribute('action') ?? ''
  if (form.classList.contains('installKit')) {
    const custom = action.includes('install_custom_kit')
    return {
      path: `/devices/${deviceId}/${door}-install/${custom ? 'custom-kit' : 'kit'}`,
      success: 'Install instruction has been sent.',
    }
  }
  if (form.classList.contains('updateKit')) {
    return {
      path: `/devices/${deviceId}/${door}-updates/kit`,
      success: 'Update command has been sent.',
    }
  }
  /*
   * Numai Uninstall. `cancelUninstallApplicationForm` nu mai pleaca aici: capatul
   * stie doar sa dezinstaleze, deci "Cancel uninstall" trimitea inca o comanda
   * UNS. In portalul vechi formularul lui n-avea ascultator deloc.
   */
  if (form.classList.contains('uninstallApplicationForm')) {
    return {
      path: `/devices/${deviceId}/softsee-uninstall/application`,
      success: 'Uninstall command has been sent.',
    }
  }
  return null
}

export async function postKitForm(
  form: HTMLFormElement,
  deviceId: number,
  door: SoftseeDoor,
): Promise<string> {
  const target = kitPostTarget(form, deviceId, door)
  if (!target) {
    throw new Error('Something went wrong.')
  }
  await apiPost(target.path, fieldsOf(form))
  return target.success
}
